// 许可证管理相关请求
import { request } from '@/utils'

// 获取许可证列表
export function getLicenseListAPI(){
  return request({
    url: '/softwareCheck/admin/getLicenseList',
    method: 'GET'
  })
}

// 更新许可证（续期 / 禁用）
export function updateLicenseAPI(data){
  return request({
    url: '/softwareCheck/admin/updateLicense',
    method: 'POST',
    data
  })
}

// 新增许可证
export function addLicenseAPI(data){
  return request({
    url: '/softwareCheck/admin/addLicense',
    method: 'POST',
    data
  })
}
